<template>
  <dialogPanel
      ref="refDialog"
      :dialogState="fdialogState"
      @event-dialog-close="eventDialogClose"
      title="测试用例"
      wth="700"
      hth="454">

    <div class="usecase-list" >
      <div v-for="item in usecaseInfo" :key="item.seq">
        <usecaseBar
            :index="item.seq"
            :usecase="item.usecase"
            :usecase-result="item.usecaseResult"
            @event-usecase-result="eventUsecaseResult"
            @event-usecase="eventUsecase"></usecaseBar>
      </div>
    </div>

    <div class="usecase-footer">
      <span @click="saveUsecase">提交</span>
    </div>
  </dialogPanel>
</template>

<script>
import dialogPanel from "@/components/panel/dialogPanel";
import usecaseBar from "@/components/panel/usecaseBar";
import serviceApi from "@/utils/serviceApi";
export default {
  name: "usercaseDialog",
  data(){
    return{
      usecaseInfo:[
        {seq:1, usecase:"", usecaseResult:""},
        {seq:2, usecase:"", usecaseResult:""},
        {seq:3, usecase:"", usecaseResult:""},
        {seq:4, usecase:"", usecaseResult:""},
        {seq:5, usecase:"", usecaseResult:""},
        {seq:6, usecase:"", usecaseResult:""},
        {seq:7, usecase:"", usecaseResult:""},
        {seq:8, usecase:"", usecaseResult:""},
        {seq:9, usecase:"", usecaseResult:""},
        {seq:10, usecase:"", usecaseResult:""}
      ]
    }
  },
  props:{
    dialogState:{
      type: Boolean,
      default: false
    }
  },
  watch: {
    'dialogState': {
        handler(newVal, oldVal) {
          if(newVal && !oldVal){
            serviceApi.loadUsecase((resultData)=>{
              this.usecaseInfo = resultData
              let startindex = resultData.length;
              for(let i = startindex, len = 10 - startindex; i < len; i ++){
                this.usecaseInfo.push(
                    {seq:i + 1, usecase:"", usecaseResult:""})
              }
            })
          }
        },
        deep: false,
        immediate: true
    }
  },
  computed:{
    fdialogState:function (){
      return this.dialogState
    }
  },
  methods: {

    eventDialogClose: function () {
      this.$emit("event-dialog-close")
    },
    eventUsecaseResult: function (index, val){
      this.usecaseInfo[index - 1].usecaseResult = val;
    },
    eventUsecase: function (index, val){
      this.usecaseInfo[index - 1].usecase = val;
    },
    saveUsecase: function (){
      serviceApi.updateUsecase(
          {
                  useCases: this.usecaseInfo
                  },
          ()=>{
            this.eventDialogClose()
          })
    }
  },
  components:{
    dialogPanel,
    usecaseBar
  }
}
</script>

<style scoped>
.usecase-list{
  box-sizing: border-box;
  height: 350px;
  overflow-y: auto;
  padding-top: 20px;
}
.usecase-footer{
  height: 50px;
  line-height: 50px;
  border-top: 1px solid #eee;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}


.usecase-footer span{
  display: block;
  border-radius: 5px;
  border: 1px solid #2e7eee;
  float: right;
  margin-left: 10px;
  height: 30px;
  line-height: 30px;
  margin-top: 10px;
  margin-right: 20px;
  padding-left: 10px;
  padding-right: 10px;
  cursor: pointer;
  color: #2e7eee;
}
.usecase-footer span:hover{
  background-color: #2e7eee;
  color: #fff;
}
</style>
